import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect } from "redux-saga/effects";
import { clearString } from "../../../utils/functions";
import api from "../../../settings/api";

export interface Fetch {
    phone?: string;
    email?: string;
    name?: string;
    plate: string;
    callback: (success: boolean, errorMessage?: string) => void;
}

export interface SendPinAvulsoAction {
    type: string;
    payload: Fetch;
}

export default function* sendPinAvulso({
    payload,
}: SendPinAvulsoAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const data: {
            licensePlate: string;
            cellphone?: string;
            email?: string;
        } = {
            licensePlate: clearString(payload.plate).toUpperCase(),
        };

        if (payload?.phone) {
            data.cellphone = clearString(payload.phone);
        } else if (payload?.email) {
            data.email = payload.email;
        }

        const response = yield call(api.post, `/v1/customers/pins`, data);

        if (response?.data?.status?.codigoRetorno === 0 || response?.status === 200) {
            yield call(payload.callback, true);
        } else {
            yield call(payload.callback, false, "error");
        }

    } catch (error) {
        yield call(payload.callback, false, "timeout");
    }
}

